import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  finalRange: [dayjs().add(-7, "d"), dayjs()],
  currency: null
};

export const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {
    updateFinalRange: (state, action) => {
      state.finalRange = action.payload;
    },
    updateCurrency: (state,action)=>{
      state.currency= action.payload;
    }
  },
});

export const { updateFinalRange,updateCurrency} = analyticsSlice.actions;

export default analyticsSlice.reducer;
